import {Controller} from "@hotwired/stimulus"
import {post} from "@rails/request.js"
// Connects to data-controller="checkin"
export default class extends Controller {
  static targets = ["checkinButton"]
  connect() {
    console.log("Checkin controller connected");
  }

  captureCameraAndRekognize(event) {
    const recognitionType = event.target.dataset.recognitionType;
    const buttonText = event.target.innerText;

    event.target.disabled = true;
    event.target.innerHTML = 'AI đang nhận dạng...💭'; // Show loading text

    // Capture image from the video stream
    const video = document.querySelector('video');
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d').drawImage(video, 0, 0);

    // Convert the canvas to a Blob and send it to the server
    canvas.toBlob((blob) => {
      let formData = new FormData();
      formData.append('image', blob, 'image.jpg');
      formData.append('recognition_type', recognitionType);

      // Dev-only mimic: include selected user ID if present
      const devSelect = document.getElementById('dev_user_id');
      if (devSelect && devSelect.value) {
        formData.append('dev_user_id', devSelect.value);
      }

      // Send the Blob data to the server using @rails/request.js
      post(`/recognize`, {
        body: formData,
        responseKind: "turbo-stream",
      }).then(() => {
        event.target.disabled = false;
        event.target.innerHTML = buttonText;
      });
    }, 'image/jpeg');  // Output blob as JPEG
  }

  // Dev-only: recognize immediately on account selection without camera
  devRecognize(event) {
    const select = event.target;
    const selectedUserId = select.value;
    if (!selectedUserId) { return }

    // Prefer role from option; fallback to 'member'
    const selectedOption = select.options[select.selectedIndex];
    const role = selectedOption?.dataset?.role || 'member';

    const formData = new FormData();
    formData.append('recognition_type', role === 'member' ? 'member' : 'staff');
    formData.append('dev_user_id', selectedUserId);

    post(`/recognize`, {
      body: formData,
      responseKind: "turbo-stream",
    });
  }
}
